/*
 * 뱃지 컴포넌트
 * https://www.figma.com/file/TJGOBLk3lZBBvLnrdThGqs/MobileApp-UI-Component?node-id=118%3A9
 * */

import Basic from './Basic';
import Compare from './Compare';
import Status from './Status';

export default {
  Basic,
  Compare,
  Status
};
